module.exports = __webpack_public_path__ + "static/media/one4all.3f801303.png";